module.exports = __webpack_public_path__ + "img/6.f84ea23a.png";